import React, {useState, useEffect} from 'react';
import { Text } from '@applane/react-core-components';
import { Table } from '../../app-components';
import { modifyDateView, shorten } from '../../Lib/helpers';
import { getUser } from '../../AppServices';
import { ROUTES } from '../../Lib/constants';


// Retrieve values from local storage
let storedData = JSON.parse(localStorage.getItem('appraisalCapturedState'));
let avCap = localStorage.getItem('avCap')

const createUri = ({ navigation }) => {

  const user = getUser();
  const userRole = user?.role?.code;

  // localStorage.removeItem('captured');

  let addOnFilter = { typeNew: 'uci' };

  const filters = navigation
  console.log('filters', filters)

  if (userRole === 'superadmin' || userRole === 'admin') {
    if (filters?.username) {
      addOnFilter = {
        ...addOnFilter,
        dealer: { username: filters.username?.value?.username },
      };
    }

    if (filters?.checkDate) {
      const { from, to } = filters?.checkDate?.value;
      addOnFilter = { ...addOnFilter, onDate: { $gte: from, $lte: to } };
    }
  } else if (userRole === 'dealer' || userRole === 'superdealer' || userRole === 'employee') {
    addOnFilter = { ...addOnFilter, dealer: { _id: getUser()?.dealer?._id } };
  }

  return {
    query: {
      id: 'allData',
      addOnFilter,
    },
    aggregate: true,
    model: 'AppraisalResultCDK',
  };
};



const tableItems = {
  lg: {
    columns: [
      avCap ? storedData?.Stock
        && {
            header: 'Stock#',
            field: 'uci.stockNumber',
            width: 200,
          }
        : {
            header: 'Stock#',
            field: 'uci.stockNumber',
            width: 200,
          },
      avCap ? storedData?.CapturedDate
          && {
              header: 'Captured Date#',
              render: ({ item }) => (
                <Text style={{ fontSize: 16 }}>{modifyDateView(item?.uci?.contractDate)}</Text>
              ),
              width: 200,
            }
          : {
              header: 'Captured Date#',
              render: ({ item }) => (
                <Text style={{ fontSize: 16 }}>{modifyDateView(item?.uci?.contractDate)}</Text>
              ),
              width: 200,
            },
      avCap ?
        storedData?.Appraisal
          && {
              header: 'Appraisal#',
              field: 'dms.repairOrderNumber',
              width: 200,
            }
          : {
              header: 'Appraisal#',
              field: 'dms.repairOrderNumber',
              width: 200,
            },
      avCap ?
        storedData?.CustomerName
          && {
              header: 'Customer Name',
              render: ({ item }) => (
                <Text style={{ fontSize: 17 }}>{shorten(item?.dms?.name, 15)}</Text>
              ),
              width: 200,
            }
          : {
              header: 'Customer Name',
              render: ({ item }) => (
                <Text style={{ fontSize: 17 }}>{shorten(item?.dms?.name, 15)}</Text>
              ),
              width: 200,
            },
      avCap ?
        storedData?.Email
          && {
              header: 'Email',
              render: ({ item }) => (
                <Text style={{ fontSize: 17 }}>
                  {item?.dms.email ? item?.dms.email : '--'}
                </Text>
              ),
              width: 400,
            }
          : {
              header: 'Email',
              render: ({ item }) => (
                <Text style={{ fontSize: 17 }}>
                  {item?.dms.email ? item?.dms.email : '--'}
                </Text>
              ),
              width: 400,
            },
      avCap ?
        storedData?.VIN
          && {
              header: 'VIN',
              field: 'dms.vin',
              width: 200,
            }
          : {
              header: 'VIN',
              field: 'dms.vin',
              width: 200,
            },
      avCap ?
        storedData?.Year
        && {
              header: 'Year',
              field: 'dms.year',
              width: 200,
            }
          : {
              header: 'Year',
              field: 'dms.year',
              width: 200,
            },
      avCap ?
        storedData?.Make
          && {
              header: 'Make',
              field: 'dms.make',
              width: 200,
            }
          : {
              header: 'Make',
              field: 'dms.make',
              width: 200,
            },
      avCap ?
        storedData?.Model
          && {
              header: 'Model',
              field: 'dms.model',
              width: 200,
            }
          : {
              header: 'Model',
              field: 'dms.model',
              width: 200,
            },
      avCap ?
        storedData?.Mileage
          && {
              header: 'Mileage',
              width: 200,
              render: ({ item }) => (
                <Text style={{ fontSize: 17 }}>
                  {item?.dms?.mileage ? item?.dms?.mileage : '--'}
                </Text>
              ),
            }
          : {
              header: 'Mileage',
              width: 200,
              render: ({ item }) => (
                <Text style={{ fontSize: 17 }}>
                  {item?.dms?.mileage ? item?.dms?.mileage : '--'}
                </Text>
              ),
            },
    ],
  },
};

export default Table({
  uri: createUri,
  ...tableItems,
  action: ({ item }) => ({
    type: 'link',
    link: {
      view: ROUTES.viewAppraisalResult.name,
      params: {
        item: { _id: item._id, type: item.type },
        showButtonsList: true,
        editable: false,
      },
    },
  }),
});
